import React, {} from "react";
import "./index.scss";
import {IMGURL} from 'lib/config'
import classNames from "classnames";
type moreProps = {
        ext: any;
  };
  const MoreProduct: React.FC<moreProps> = ({ext}) => {
  return (
    <>
   <div className={classNames("search_more")}>
            <div className="search_product">
              <img src={`${IMGURL}${ext.img1}`} alt="" />
            </div>
            <div className="search_product">
              <img src={`${IMGURL}${ext.img2}`} alt="" />
            </div>
          </div>
    </>
  )
  }
  export default MoreProduct;